// Provider es una estructura básica para realizar consultas a una base de datos
// Utilizando axios, incluye las consultas CRUD básicas
import dbConnection from './dbConnection';
import { handleError, handleResponse } from './Response';

export const ApiProvider = () => {
    
    const getAll = (resource, config= null) => {
        return dbConnection
            .get(`/${resource}`, config )
            .then(handleResponse)
            .catch(handleError)
    };
    
    const getSingle = (resource, id) => {
        return dbConnection
            .get(`/${resource}/${id}`)
            .then(handleResponse)
            .catch(handleError)
    };
    
    const post = (resource, model) => {
        return dbConnection
            .post(`/${resource}`, model)
            .then(handleResponse)
            .catch(handleError)
    }
    
    const put = async(resource, model) => {
        return dbConnection
            .put(`/${resource}/${ model._id }`, model)
            .then(handleResponse)
            .catch(handleError)
    }
    
    const patch = (resource, model) => {
        return dbConnection
            .patch(`/${resource}`, model)
            .then(handleResponse)
            .catch(handleError)
    }
    
    const remove = (resource, id) => {
        return dbConnection
            .delete(`/${resource}/${id}`)
            .then(handleResponse)
            .catch(handleError)
    }

    return ({
        getAll,
        getSingle,
        post,
        put,
        patch,
        remove,
    })

}
